import { useRecoilState } from 'recoil';

import { genericListSortingState } from '../../store/sorting';

import { OrderCycleMode, TableHeadItemOrderBy, TableHeadItemRecurse } from '.';

export const useSortHandler = (listKey: string, orderCycleMode: OrderCycleMode = 'partial') => {
  const [listSortingState, setListSortingState] = useRecoilState(genericListSortingState(listKey));

  const handleSort = (item: TableHeadItemRecurse) => {
    const orderValue = item.orderValue as string | undefined;

    if (!orderValue) {
      return;
    }

    setListSortingState((prev) => {
      if (prev?.sortKey !== orderValue) {
        return { sortKey: orderValue, sortDirection: 'asc' };
      }

      if (prev.sortDirection === 'asc') {
        return { sortKey: orderValue, sortDirection: 'desc' };
      }

      return orderCycleMode === 'full'
        ? { sortKey: null, sortDirection: null }
        : { sortKey: orderValue, sortDirection: 'asc' };
    });
  };

  const orderBy: TableHeadItemOrderBy = {
    value: listSortingState?.sortKey ?? '',
    direction: listSortingState?.sortDirection ?? 'asc',
  };

  return [handleSort, orderBy] as const;
};
